import './index.scss';

import React from 'react';
import SVG from "react-inlinesvg";
import {DEBUG_MODE} from "../../config";

export const EntryFormGroup = ({icon, title, children}) => {
    return (
        <div className="entry-form-group">
            <div className="efg-header">
                <SVG src={icon} />
                <div>{title}</div>
            </div>
            {DEBUG_MODE && <div className="debug-container">{JSON.stringify({icon, title})}</div>}
            <div className="efg-container">
                {children}
            </div>
        </div>
    );
};
